
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DateRangePicker extends Vue {
  @Prop({ default: () => new Date() })
  maxDate!: Date;

  @Prop({ default: () => new Date("2022-01-01T11:03:19.321Z") }) // there should never be any log entry for a time where this product didn't exist yet ^^
  minDate!: Date;

  @Prop({
    default: () => [moment().subtract(7, "day").toDate(), moment().toDate()],
  })
  initialRange!: [Date, Date] | [Date];

  dateRange: [string, string] | [string] = [""];
  suppressNextInput = false;

  mounted(): void {
    this.syncInitialRange();
  }

  get maxBound(): string | undefined {
    return this.maxDate ? this.maxDate.toISOString() : undefined;
  }

  get minBound(): string | undefined {
    return this.minDate ? this.minDate.toISOString() : undefined;
  }

  get sortedDateRange(): [Date, Date] | [Date] {
    return this.dateRange
      .map((s) => new Date(s))
      .sort((d1, d2) => d1.getTime() - d2.getTime()) as [Date, Date];
  }

  @Watch("sortedDateRange")
  onDateRangeChanged(dateRange: [Date, Date] | [Date]): void {
    if (this.suppressNextInput) {
      this.suppressNextInput = false;
      return;
    }

    this.$emit("input", dateRange);
  }

  @Watch("initialRange", { deep: true })
  onInitialRangeChanged(): void {
    this.syncInitialRange();
  }

  private syncInitialRange(): void {
    const nextRange = this.initialRange.map((d) => d.toISOString()) as [
      string,
      string
    ] | [string];

    if (JSON.stringify(this.dateRange) === JSON.stringify(nextRange)) {
      return;
    }

    this.suppressNextInput = true;
    this.dateRange = nextRange;
  }

  get dateRangeText(): string {
    return `${new Date(this.sortedDateRange[0]).toLocaleDateString()} - ${
      this.sortedDateRange[1]
        ? new Date(this.sortedDateRange[1]).toLocaleDateString()
        : ""
    }`;
  }
}
